/* ═══════════════════════════════════════════════════════════════
   Tealibere — Scroll-triggered animations (IntersectionObserver)
   Plan ref: B-SOP-B2.2
   No jQuery · No external deps · 1.2 KB unminified
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /** Elements with these classes get `.is-visible` when entering the viewport */
  var SELECTORS = '.tl-fade-up, .tl-scale-reveal';

  if (!('IntersectionObserver' in window)) {
    // Fallback: show everything immediately for old browsers
    document.querySelectorAll(SELECTORS).forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // fire once
        }
      });
    },
    { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
  );

  function observe() {
    document.querySelectorAll(SELECTORS).forEach(function (el) {
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });
  }

  // Expose for dynamically added elements (e.g. FAQ accordion)
  window.tlObserveNew = observe;

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // Re-observe after Shopify section rendering (theme editor, AJAX)
  document.addEventListener('shopify:section:load', observe);
})();
